import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const tabParent = (theme: Theme, selectedAssetInfoIsLoading: boolean) => css`
  height: 100%;
  max-height: 100%;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  color: ${theme.palette.uintel.main};
  font-size: 14px;
  opacity: ${selectedAssetInfoIsLoading ? 0.5 : 1};
  transition: opacity 0.2s ease-in-out;

  h2 {
    font-size: 20px;
    font-weight: 500;
    line-height: 14px;
    margin-bottom: 12px;
  }

  h3 {
    padding: 10px 0;
    font-size: 14px;
    font-weight: 700;
    line-height: 130%;
  }
`

export const scrollContainer = () => css`
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 16px;
  overflow-y: auto;
`

export const tableStyle = css`
  width: 100%;
  border-collapse: collapse;
  color: black;
  background-color: white;
  border-radius: 4px;
`

export const thTdKeyStyle = css`
  font-weight: bold;
  padding: 8px 16px;
  border-bottom: 1px solid #e0e0e0;
  color: black;
  width: 40%;
`

export const thTdValueStyle = css`
  padding: 8px 16px;
  border-bottom: 1px solid #e0e0e0;
  color: black;
`

export const noDetailsStyle = css`
  color: #6b7280; /* fallback for theme.text.secondary */
`

export const tableParent = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 12px;
`

export const footerButtonsContainer = (theme: Theme) => css`
  display: flex;
  justify-content: space-between;
  padding: 16px;
  width: 100%;
  background-color: ${theme.palette.background.paper};
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  flex-direction: row-reverse;
  z-index: 1;

  button {
    background-color: ${theme.palette.uintel[400]};
  }
`

export const tooltipArrow = (arrowColor: string) => css`
  position: absolute;
  width: 8px;
  height: 16px;
  left: -8px;
  bottom: 12px;
  background-color: ${arrowColor};
  clip-path: polygon(100% 0%, 0% 50%, 100% 100%);
`
